module.exports = __webpack_public_path__ + "db0246dcb22f1e0b5e4d3916adf927c5.jpg";